// ════════════════════════════════════════════════════════════
//  text.js — THE WORDS. Every line the game says comes through here.
// ════════════════════════════════════════════════════════════
//  caP'n, 2026-10-16: "seriously every single text of words should be editable".
//  The words live in data/text.json (edited by The Sun Dial, or by hand; the dev
//  game reloads live). data/text.original.json is the untouched factory copy.
//  RULES OF THIS FILE
//   • a line that is MISSING from text.json falls back to the factory copy, never
//     to a crash; a line that is present but EMPTY stays empty (caP'n may want it).
//   • {A} {B} {name} {n} are filled by the game; unknown {braces} stay as typed.
//   • a list the game cannot run without (Willie's script) falls back to the
//     factory list if it is emptied; a list it can (sign gags) may be empty.
// ════════════════════════════════════════════════════════════
import raw from "./text.json";
import orig from "./text.original.json";

const has = (o, k) => !!o && Object.prototype.hasOwnProperty.call(o, k);

export function fmt(s, vars) {
  return String(s).replace(/\{(\w+)\}/g, (m, k) => (vars && has(vars, k) && vars[k] != null ? String(vars[k]) : m));
}

// one line, by key
export function say(key, vars) {
  const mine = raw && raw.lines;
  const v = has(mine, key) && typeof mine[key] === "string" ? mine[key] : has(orig.lines, key) ? orig.lines[key] : key;
  return fmt(v, vars);
}

// a list, by key. `min` = how many it needs to be usable (else the factory list)
export function listOf(key, min = 0) {
  const a = raw && raw.lists && raw.lists[key];
  if (Array.isArray(a) && a.length >= min) return a;
  return (orig.lists && orig.lists[key]) || [];
}
